// extracted by mini-css-extract-plugin
export var footer = "_pg-0";
export var inherit = "_pg-1";
export var input = "_pg-2";
export var modalContent = "_pg-3";
export var quillEditor = "_pg-4";
export var subtitle = "_pg-5";